import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
const runtimeConfig = require('../functions/src/config/rtc.json')

const sentryProjects = {
  development:
    'https://9bd37f27cc7f438784e68ac11bbdb375@o544550.ingest.sentry.io/1376665',
  test: 'https://3db2257714134441b1cf7db0cbca1be3@o544550.ingest.sentry.io/1387725',
  production:
    'https://8ba884187e9a42a985a41c21759e0b7e@o544550.ingest.sentry.io/1387727'
}

const log = (...args) => {
  /* eslint-disable no-console */
  console.log(...args)
}

const error = (...args) => {
  /* eslint-disable no-console */
  console.error(...args)
}

function init(Vue) {
  Vue.prototype.$Sentry = Sentry

  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: sentryProjects[runtimeConfig.app.env],
      integrations: [new Integrations.Vue({ Vue })]
    })
  } else {
    Sentry.init({
      dsn: sentryProjects[runtimeConfig.app.env],
      beforeSend(event, hint) {
        log('%cSentry in Prod.', 'color: blue; font-weight: bold;')
        error(hint.originalException)
        return null
      }
    })
    Vue.config.errorHandler = function (err, vm, info) {
      log('%cSentry in Prod. Vue', 'color: blue; font-weight: bold;')

      if (err) {
        throw err
      } else {
        log(err, vm, info)
      }
    }
  }
}

export default { init }
